import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { Engineeri8AppStateReducer } from './engineeri8.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Engineeri8AppDBEffects } from './engineeri8.effects';

@NgModule({
  imports: [
    StoreModule.forRoot(Engineeri8AppStateReducer),
    EffectsModule.forRoot(Engineeri8AppDBEffects),
    StoreDevtoolsModule.instrument({ maxAge: 10 }),
  ],
})
export class Engineeri8ReduxStoreModule {}
